import { graphql, SliceComponentProps } from "gatsby";
import React from "react";
import { SubscribeToNewsletterPopupSliceQuery } from "types/graphql-types";
import SliceProviders from "./SliceProviders";
import { SubscribeToNewsletterSliceContext } from "./types";
import MaybeSubscribeToNewsletterPopup from "components/SubscribeToNewsletter/SubscribeToNewsletterPopup/MaybeSubscribeToNewsletterPopup";
import ClientOnly from "components/ClientOnly";

const SubscribeToNewsletterPopupSlice: React.FC<
  SliceComponentProps<
    SubscribeToNewsletterPopupSliceQuery,
    SubscribeToNewsletterSliceContext
  >
> = ({ data, sliceContext }) => {
  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <ClientOnly>
        <MaybeSubscribeToNewsletterPopup
          subscribeFormContent={{
            headingTitle: data.subscribeFormContent?.heading?.title?.localized,
            headingContent:
              data.subscribeFormContent?.heading?.content?.localized,
            customHeadingTitle:
              data.subscribeFormContent?.customPromoHeading?.title?.localized,
            customHeadingContent:
              data.subscribeFormContent?.customPromoHeading?.content?.localized
          }}
          backgroundImage={data.subscribeFormContent?.backgroundImage}
          formDisclaimerContent={data.formDisclaimerContent}
          privacyPolicyUrl={sliceContext.privacyPolicyUrl}
          offerPageUrl={data.offerPage?.fullPath}
          promoConfigurationCode={
            data.subscribeFormContent?.promoConfiguration?.code
          }
        />
      </ClientOnly>
    </SliceProviders>
  );
};

// eslint-disable-next-line import/no-unused-modules
export const query = graphql`
  query SubscribeToNewsletterPopupSlice {
    subscribeFormContent: subscribeToNewsletterContent {
      heading {
        title {
          localized
        }
        content {
          localized
        }
      }
      backgroundImage {
        ...ImageWithAlt
      }
      promoConfiguration {
        code
      }
      customPromoHeading {
        title {
          localized
        }
        content {
          localized
        }
      }
    }
    formDisclaimerContent: sanityFormDisclaimer {
      ...FormDisclaimer
    }
    offerPage: sanityPage(
      _id: { in: ["page-exclusive-offers", "drafts.page-exclusive-offers"] }
    ) {
      fullPath
    }
  }
`;

export default SubscribeToNewsletterPopupSlice;
